var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articlePage"},[_c('div',{staticStyle:{"padding":"0px 28px 20px 28px"}},[_c('div',{staticClass:"articlePage_title"},[_vm._v(_vm._s(_vm.articleTitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.showHtmlData)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }